import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Value } from 'slate';
import { Editor as SlateEditor } from 'slate-react';
import EmptyPlaceholder from './EmptyPlaceholder';
import PerfAnalyticsHelper from '../../helpers/PerfAnalyticsHelper';
import { IS_FIREFOX, document } from '../../helpers/BrowserHelpers';
import { EDITOR_PERFORMANCE } from '../../types/AnalyticsTypes';
import './style.css';

var defaultRenderBlock = function defaultRenderBlock(_ref) {
  var node = _ref.node,
      attributes = _ref.attributes,
      children = _ref.children;
  return React.createElement("div", Object.assign({
    "data-type": node.type
  }, attributes), children);
};

var defaultRenderInline = function defaultRenderInline(_ref2) {
  var node = _ref2.node,
      attributes = _ref2.attributes,
      children = _ref2.children;
  return React.createElement("span", Object.assign({
    "data-type": node.type
  }, attributes), children);
};

var renderPlaceholder = function renderPlaceholder(placeholder) {
  return function (props, editor, next) {
    if (props.decoration.type === 'placeholder') {
      return React.createElement(EmptyPlaceholder, Object.assign({
        placeholder: props.decoration.getIn(['data', 'placeholder']) || placeholder
      }, props));
    }

    return next();
  };
};

var Editor =
/*#__PURE__*/
function (_Component) {
  _inherits(Editor, _Component);

  function Editor(props) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Editor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onVisibilityChange", function () {
      if (!_this.editor) return;
      var selection = _this.editor.value.selection;

      if (!document.hidden && selection.isSet && selection.isFocused) {
        _this.editor.deselect();

        _this.visibilityTimeout = setTimeout(function () {
          return _this.editor && _this.editor.select(selection).focus();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onEditorRef", function (editor) {
      _this.editor = editor;
      if (_this.props.onEditorRef) _this.props.onEditorRef(editor);

      _this.sendTrack();
    });

    _defineProperty(_assertThisInitialized(_this), "onIdle", function () {
      _this.logsReady = true;

      _this.sendTrack();
    });

    _defineProperty(_assertThisInitialized(_this), "sendTrack", function () {
      if (!_this.editor || !_this.logsReady || _this.logsSent || !_this.props.logPerformances) return;
      _this.logsSent = true;

      _this.editor.command('track', EDITOR_PERFORMANCE, PerfAnalyticsHelper.logs());
    });

    _this.plugins = [].concat(_toConsumableArray(props.plugins), [{
      renderBlock: defaultRenderBlock,
      renderInline: defaultRenderInline,
      renderDecoration: renderPlaceholder(props.placeholder)
    }, {
      onChange: _this.props.onChange,
      onError: _this.props.onError
    }]);
    _this.logsReady = false;
    _this.logsSent = false;
    return _this;
  }

  _createClass(Editor, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.props.onError(error);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if (this.props.logPerformances) {
        PerfAnalyticsHelper.logMountTime();
        PerfAnalyticsHelper.logValueStats(this.props.value);
        PerfAnalyticsHelper.logIdleTime(this.onIdle);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      clearTimeout(this.visibilityTimeout);
    } // TODO: Remove me when the following issue is merged
    // https://github.com/ianstormtaylor/slate/pull/2657

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          className = _this$props.className,
          readOnly = _this$props.readOnly,
          spellCheck = _this$props.spellCheck,
          placeholder = _this$props.placeholder;
      return React.createElement(SlateEditor, {
        className: classNames(className, {
          'is-firefox': IS_FIREFOX
        }),
        ref: this.onEditorRef,
        plugins: this.plugins,
        value: value,
        readOnly: readOnly,
        spellCheck: spellCheck,
        placeholder: placeholder
      });
    }
  }]);

  return Editor;
}(Component);

_defineProperty(Editor, "propTypes", {
  className: PropTypes.string,
  placeholder: PropTypes.any,
  plugins: PropTypes.array,
  value: PropTypes.instanceOf(Value).isRequired,
  readOnly: PropTypes.bool,
  spellCheck: PropTypes.bool,
  logPerformances: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onEditorRef: PropTypes.func
});

_defineProperty(Editor, "defaultProps", {
  onError: function onError(error) {
    return console.error(error);
  },
  logPerformances: false
});

export { Editor as default };